import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { PendingPaymentBranch } from '../../../../api/types/accountants/salaries-pending-payments/salaries-pending-payments.type';
import globalSalaryStore from '../../../../stores/accountant/global-salary-store';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';

export const generatePayrollReportOperation = async (
  user: UserSummaryType,
  startTime: Date,
  endTime: Date,
  includeRetroactivePayments: boolean,
  setPendingPaymentByBranch: (
    pendingPaymentByBranch: PendingPaymentBranch[],
  ) => any,
) => {
  try {
    const res = await appApi.generatePayrollReport(
      user.id,
      startTime,
      endTime,
      includeRetroactivePayments,
    );
    setPendingPaymentByBranch(res.data.body as PendingPaymentBranch[]);
    globalSalaryStore.user = user;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
